<template>
   <div v-show="show_overlay" class="overlay" @click.self="$emit('closeCarousel')">
      <i class="icon icon-cancel" @click.self="$emit('closeCarousel')" />
      <carousel
         v-if="show_carousel"
         class="carousel"
         :perPage="1"
         :navigationEnabled="true"
         :navigationClickTargetSize="16"
         :paginationSize="0"
         :v-model="page"
         :navigate-to="[open_on_page, false]"
      >
         <slide class="slide d-flex" v-for="(image_source, index) in images_source" :key="image_source">
            <carousel-image :index="index" :image_source="image_source" />
         </slide>
      </carousel>
   </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
   components: {
      carouselImage: () => import('@/modules/journeys/components/question/carouselImage.vue'),
      Carousel,
      Slide,
   },
   props: {
      images_source: {
         type: Array,
         default: [],
      },
      open_on_page: {
         type: Number,
         default: 0,
      },
   },

   data() {
      return {
         show_carousel: false,
         page: 0,
         show_overlay: false,
      };
   },

   mounted() {
      this.show_carousel = true;
      setTimeout(() => {
         this.page = this.open_on_page;
         this.show_overlay = true;
      }, 80);
   },
};
</script>

<style lang="scss" scoped>
.overlay {
   position: fixed;
   display: flex;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   overflow: auto;
   background: #000000bb;
   z-index: 4;
   color: white;
}

.carousel {
   margin: auto;
   max-width: 90vw;
}

.icon {
   right: 16px;
   top: 16px;
   font-size: 1.2rem;
   position: absolute;
}
</style>
<style lang="scss">
.VueCarousel-navigation-prev,
.VueCarousel-navigation-next {
   color: white !important;
   &:focus {
      outline: none !important;
   }
}

.VueCarousel-pagination {
   height: 0 !important;
   width: 0 !important;
   display: none !important;
}
</style>

